module.exports = __webpack_public_path__ + "static/img/ra800-detection1.dd894fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ra800-detection1.png
// module id = 0Euc
// module chunks = 1